import React from "react";
import Container from "src/components/common/Layout/Container";
import { Typography, Box } from "@mui/material";
import Link from "src/components/common/Links/Link";
import { colors } from "src/config/colors";
import Slider, { ResponsiveObject, Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SliderArrowButton } from "src/components/common/CardSlider/SliderArrows/sliderArrows";
import { ArrowDirection } from "src/components/common/CardSlider/SliderArrows/utils/arrowDirection";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/system";
import ProductCard from "src/components/common/CardSlider/ProductCard/ProductCard";
import { AnalogsSchema } from "src/models/newProduct/getAnalogs";
import { createUrl } from "src/utils/helpers/url/createUrl";

interface AnalogsSectionParams {
  analogs?: AnalogsSchema;
  isLoadingAnalogs: boolean;
}

const AnalogsSection: React.FC<AnalogsSectionParams> = ({
  analogs,
  isLoadingAnalogs,
}) => {
  const isLargeScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("lg")
  );

  if (!analogs) return null;

  const unslick = "unslick" as ResponsiveObject["settings"];

  const settings: Settings = {
    arrows: isLargeScreen,
    dots: true,
    infinite: analogs.items.length > 2,
    swipe: true,
    variableWidth: false,
    speed: 500,
    slidesToScroll: 3,
    slidesToShow: 3,
    dotsClass: "slick-dots",
    /*beforeChange: () => setClickable(false),
    afterChange: () => setClickable(true),*/
    prevArrow: <SliderArrowButton to={ArrowDirection.LEFT} />,
    nextArrow: <SliderArrowButton to={ArrowDirection.RIGHT} />,
    responsive: [
      {
        breakpoint: 3000,
        settings:
          analogs.items.length < 2
            ? unslick
            : {
                slidesToScroll: 2,
                variableWidth: true,
              },
      },
      {
        breakpoint: 1200,
        settings:
          analogs.items.length < 2
            ? unslick
            : {
                slidesToScroll: 2,
                slidesToShow: 3,
                variableWidth: true,
              },
      },
      {
        breakpoint: 900,
        settings:
          analogs.items.length < 2
            ? unslick
            : {
                slidesToScroll: 2,
                slidesToShow: 3,
                variableWidth: true,
              },
      },
      {
        breakpoint: 600,
        settings:
          analogs.items.length < 2
            ? unslick
            : {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
              },
      },
    ],
  };

  return (
    <Container
      isWithPaper
      paddingX="0px"
      wrapperSx={{
        padding: "24px",
        borderRadius: "8px",
        mt: 3,
        paddingBottom: "34px",
      }}
      id="analogs"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 3,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "16px", tb: "24px" },
            fontWeight: 500,
            color: colors.black2,
          }}
        >
          Аналоги
        </Typography>
        {analogs.items.length != 0 && (
          <Link
            sx={{
              display: analogs.items.length === 0 ? "none" : "block",
              color: colors.blue2,
              fontSize: { xs: "12px", tb: "14px" },
            }}
            href={createUrl([analogs.all_analogs_url])}
          >
            Смотреть все аналоги
          </Link>
        )}
      </Box>
      {analogs && analogs.items.length === 0 ? (
        <Typography
          sx={{
            fontSize: "16px",
            color: colors.black2,
          }}
        >
          К сожалению, аналогов не нашлось, но мы в поиске и в ближайшие
          несколько дней сделаем подборку товаров.
        </Typography>
      ) : (
        <>
          <Typography
            component="div"
            sx={{
              fontSize: { xs: "14px", tb: "16px" },
              color: colors.black2,
              marginBottom: "32px",
            }}
          >
            Обязательно проконсультируйтесь c врачом
          </Typography>
          <Box
            sx={{
              paddingRight: "16px",
            }}
          >
            <Slider {...settings}>
              {analogs.items.map((value, index) => (
                <ProductCard
                  isLoadingAnalogs={isLoadingAnalogs}
                  key={value.full_slug}
                  image={value.image}
                  full_slug={value.full_slug}
                  offers_amount={value.offers_amount}
                  name={value.name}
                  advertisement={value.is_advertisement}
                  company={value.company}
                  country={value.country}
                  min_price={value.min_price}
                  slug={value.slug}
                />
              ))}
            </Slider>
          </Box>
        </>
      )}
    </Container>
  );
};

export default AnalogsSection;
